import { API } from "aws-amplify";
import { apiGateway } from "../../config";
import { store } from "../";
import {
  ADD_PROJECTS,
  ADD_PROJECT,
  ADD_PROMPTS,
  UPDATE_PROJECT,
  REMOVE_PROJECT,
  FETCHING_PROJECTS,
  FETCHED_PROJECTS,
  FETCHING_PROJECT,
  FETCHED_PROJECT,
  FETCHING_PROMPTS,
  FETCHED_PROMPTS,
  OPEN_SURVEY,
  CLOSE_SURVEY,
  LOADING_BLOCKS,
  SET_DOCUMENT,
  STORE_PROJECT_SETTINGS,
  SET_ADAPTIVE,
  ADD_QUERIES,
  FETCHING_QUERIES,
  FETCHED_QUERIES,
  UPDATE_QUERY,
  SET_ACTIVE_CONVERSATION,
  SET_ACTIVE_CONVERSATION_FOCUS,
  CLEAR_KB_UNLOCK,
  SET_ACCOUNT_ASSISTANT_QUERIES,
  SET_SPOTLIGHT_DATA
} from "./constants";
import { getAccountUsers } from "./users";
import debug from "../../utilities/debug";
import axios from "axios";
import { getUser } from "./user";
import { fetchDiagnoses } from "../../utilities";
import { getAccounts } from "./accounts";
import { showNotification } from "./notification";
const Gateway = apiGateway.find((gateway) => gateway.name === "client");

// Rotate ingestion token (developer mode only backend)
export const rotateIngestionToken = (project_id) => async (dispatch) => {
  return API.post(Gateway.name, `/projects/ingest/rotate/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body: {}
  })
    .then(async (resp) => {
      if (resp.success) {
        // Refetch project FIRST (it returns the stored hashed v2.* token).
        // Awaiting prevents the refetch from racing past the plaintext patch
        // below and overwriting it via UPDATE_PROJECT in the reducer.
        try {
          await dispatch(getProject(project_id, true));
        } catch (_) {
          // refetch is best-effort; continue with plaintext patch even if it fails
        }
        // Backend stores hashed token (v2.*) and only returns plaintext on rotate.
        // Keep plaintext in memory so UI can show/copy it once after rotation.
        if (resp.ingestion_token) {
          dispatch({
            type: UPDATE_PROJECT,
            payload: {
              id: Number(project_id),
              ingestion_token: resp.ingestion_token
            }
          });
        }
        dispatch(showNotification('success', 'Token Rotated', 'Ingestion token updated.'));
      } else {
        dispatch(showNotification('error', 'Rotate Failed', resp.message || 'Could not rotate token'));
      }
      return resp;
    })
    .catch((error) => {
      dispatch(showNotification('error', 'Rotate Failed', error?.response?.data?.message || 'Could not rotate token'));
      return { success:false };
    });
};

// Conversation helpers
export const setActiveConversation = (conversationId) => (dispatch) => {
  dispatch({ type: SET_ACTIVE_CONVERSATION, payload: conversationId });
  return conversationId;
};

export const setActiveConversationFocus = (queryId) => (dispatch) => {
  dispatch({ type: SET_ACTIVE_CONVERSATION_FOCUS, payload: queryId });
};
export const getProjects = (override) => async (dispatch) => {
  if ((!store.getState().projects.fetching && !store.getState().projects.fetched) || override) {
    dispatch({ type: FETCHING_PROJECTS, payload: true });
    return API.get(Gateway.name, `/projects/get-all/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: ADD_PROJECTS, payload: { list: data.payload, total: data.accountTotal } });
        dispatch({ type: FETCHING_PROJECTS, payload: false });
        dispatch({ type: FETCHED_PROJECTS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: ADD_PROJECTS, payload: { list: [], total: error.response?.data?.accountTotal || 0 } });
        dispatch({ type: FETCHING_PROJECTS, payload: false });
        dispatch({ type: FETCHED_PROJECTS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const createProject = (project) => async (dispatch) => {
  return API.post(Gateway.name, `/projects/create/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      project
    },
  })
    .then((newProject) => {
      if (newProject.success) {
        return dispatch(getAccountUsers(store.getState().session.account.account_id, store.getState().authentication.user.cognito_id, true))
        .then(async () => {
          await getUser(store.getState().authentication.user.cognito_id, store.getState().session.account.account_id, true);
          dispatch({ type: ADD_PROJECT, payload: newProject.payload });
          // Reset KB unlock flow for new project
          dispatch({ type: CLEAR_KB_UNLOCK });
          return newProject;
        });
      }
      return newProject;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const createPartnerProject = (project) => async (dispatch) => {
  return API.post(Gateway.name, `/projects/partners/create/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      project
    },
  })
    .then((newProject) => {
      // Reset KB unlock flow for new project
      dispatch({ type: CLEAR_KB_UNLOCK });
      return newProject;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const updateProject = (project_id, updates) => async (dispatch) => {
  return API.patch(Gateway.name, `/projects/update/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      updates
    },
  })
    .then((updated) => {
      dispatch({ type: UPDATE_PROJECT, payload: updated.payload });
      return updated;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const removeProject = (project_id) => async (dispatch) => {
  return API.del(Gateway.name, `/projects/delete/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
  })
    .then((updated) => {
      if (updated?.success) {
        dispatch({ type: REMOVE_PROJECT, payload: project_id });
        dispatch(showNotification("success", "Plan Deleted", updated.message || "Successfully deleted plan."));
      } else {
        dispatch(showNotification("error", "Delete Failed", updated?.message || "Could not delete this plan."));
      }
      return updated;
    })
    .catch((error) => {
      const payload = {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
      dispatch(showNotification("error", "Delete Failed", payload.message));
      return payload;
    });
};

export const getProject = (project_id, silent = false) => async (dispatch) => {
  if (!silent) dispatch({ type: FETCHING_PROJECT, payload: true });
  return API.get(Gateway.name, `/projects/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    }
  })
    .then((response) => {
      dispatch({ type: UPDATE_PROJECT, payload: response.payload });
      if (!silent) {
        dispatch({ type: FETCHING_PROJECT, payload: false });
        dispatch({ type: FETCHED_PROJECT, payload: true });
        dispatch({ type: LOADING_BLOCKS, payload: [] });
      }
      return response;
    })
    .catch((error) => {
      if (!silent) {
        dispatch({ type: FETCHING_PROJECT, payload: false });
        dispatch({ type: FETCHED_PROJECT, payload: true });
        dispatch({ type: LOADING_BLOCKS, payload: [] });
      }
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};
export const setDocument = (data) => async (dispatch) => {
  dispatch({ type: SET_DOCUMENT, payload: data });
};
export const openSurvey = (block, segment) => async (dispatch) => {
  dispatch({ type: OPEN_SURVEY, payload: { ...block, active_segment: segment } });
};
export const closeSurvey = () => async (dispatch) => {
  dispatch({ type: CLOSE_SURVEY });
};
export const storeProjectSettings = (project_id, settings) => async (dispatch) => {
  dispatch({ type: STORE_PROJECT_SETTINGS, payload: { project_id, settings } });
};

export const getFoods = async (query) => {
  return axios.get(`https://api.edamam.com/auto-complete?app_id=59e3f1e3&app_key=8fad27c4d135c4b56659e71ce530af4e&q=${query}`, {
    disableMultipart: true,
    headers: {
      'Content-Type': "application/json"
    }
  })
    .then((results) => results.data)
    .catch(() => [])
};

export const SearchDiagnoses = async (term) => {
  return await fetchDiagnoses(term);
};

export const getPrompts = (project_id, override) => async (dispatch) => {
  if ((!store.getState().prompts.fetching && !store.getState().prompts.fetched[project_id]) || override) {
    dispatch({ type: FETCHING_PROMPTS, payload: true });
    return API.get(Gateway.name, `/prompts/get-all/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: ADD_PROMPTS, payload: { list: data.payload, prompt_reminders: data.prompt_reminders, project_id } });
        dispatch({ type: FETCHING_PROMPTS, payload: false });
        dispatch({ type: FETCHED_PROMPTS, payload: { status: true, project_id } });
        return data;
      })
      .catch((error) => {
        dispatch({ type: ADD_PROMPTS, payload: { list: [], project_id } });
        dispatch({ type: FETCHING_PROMPTS, payload: false });
        dispatch({ type: FETCHED_PROMPTS, payload: { status: true, project_id } });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const getQueries = (project_id, override) => async (dispatch) => {
  if ((!store.getState().prompts.queries?.fetching && !store.getState().prompts.queries?.fetched?.[project_id]) || override) {
    dispatch({ type: FETCHING_QUERIES, payload: true });
    return API.get(Gateway.name, `/prompts/get-queries/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        const currentList = store.getState().prompts.queries?.list?.[project_id] || [];
        const incoming = data.payload || [];
        const merged = incoming.map((shallow) => {
          const existing = currentList.find((c) => c.id === shallow.id);
          if (existing && (existing.metadata != null || existing.is_shallow === false)) return existing;
          return shallow;
        });
        currentList.forEach((c) => {
          if (!merged.some((m) => m.id === c.id)) merged.push(c);
        });
        dispatch({ type: ADD_QUERIES, payload: {
          list: merged,
          project_id
        } });
        dispatch({ type: FETCHING_QUERIES, payload: false });
        dispatch({ type: FETCHED_QUERIES, payload: { status: true, project_id } });
        return data;
      })
      .catch((error) => {
        dispatch({ type: ADD_QUERIES, payload: { list: [], project_id } });
        dispatch({ type: FETCHING_QUERIES, payload: false });
        dispatch({ type: FETCHED_QUERIES, payload: { status: true, project_id } });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const getAccountQueries = (override) => async (dispatch) => {
  // Use user's PRIMARY account, not switched context account (important for partners)
  const state = store.getState();
  const account_id = state.accounts.primary?.account_id || state.session.account?.account_id;
  const cognito_id = state.authentication.user.cognito_id;
  const token = state.session.token;
  
  if (!account_id) {
    debug.error('[getAccountQueries] No account_id available');
    return { success: false, message: 'Account not loaded' };
  }
  
  return API.get(Gateway.name, `/prompts/get-queries/account/${account_id}/${cognito_id}`,
    {
      headers: {
        Authorization: token
      }
    })
    .then((data) => {
      const incoming = data.payload || [];
      const currentList = store.getState().accountAssistant?.queries || [];
      const merged = incoming.map((shallow) => {
        const existing = currentList.find((c) => c.id === shallow.id);
        if (existing && (existing.metadata != null || existing.is_shallow === false)) return existing;
        return shallow;
      });
      currentList.forEach((c) => {
        if (!merged.some((m) => m.id === c.id)) merged.push(c);
      });
      dispatch({ type: SET_ACCOUNT_ASSISTANT_QUERIES, payload: merged });
      return data;
    })
    .catch((error) => {
      dispatch({ type: SET_ACCOUNT_ASSISTANT_QUERIES, payload: [] });
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

/**
 * Fetch shallow spotlight data (projects, documents, recent queries) for global search.
 * Used when Spotlight opens so we don't rely on per-project fetches.
 */
export const getSpotlightData = (opts = {}) => async (dispatch) => {
  const state = store.getState();
  const account_id = state.accounts.primary?.account_id || state.session.account?.account_id;
  const cognito_id = state.authentication.user?.cognito_id;
  const token = state.session.token;
  if (!account_id || !cognito_id) return { success: false, message: 'Not loaded' };
  const params = new URLSearchParams();
  if (opts.q) params.set('q', opts.q);
  if (opts.limit_plans != null) params.set('limit_plans', opts.limit_plans);
  if (opts.limit_documents != null) params.set('limit_documents', opts.limit_documents);
  if (opts.limit_queries != null) params.set('limit_queries', opts.limit_queries);
  const qs = params.toString();
  const path = `/projects/spotlight-data/${account_id}/${cognito_id}${qs ? `?${qs}` : ''}`;
  return API.get(Gateway.name, path, { headers: { Authorization: token } })
    .then((data) => {
      dispatch({ type: SET_SPOTLIGHT_DATA, payload: data.payload || { projects: [], documents: [], queries: [] } });
      return data;
    })
    .catch((error) => {
      dispatch({ type: SET_SPOTLIGHT_DATA, payload: null });
      return { success: false, message: error.response?.data?.message || 'Failed to load spotlight data' };
    });
};


// Fetch full conversation details (complete responses, no truncation)
export const getFullConversation = (conversation_id, project_id = null) => async (dispatch) => {
  const state = store.getState();
  const account_id = state.session.account?.account_id;
  const cognito_id = state.authentication.user.cognito_id;
  const token = state.session.token;
  
  if (!account_id || !conversation_id) {
    return { success: false, message: 'Missing required parameters' };
  }
  
  return API.get(Gateway.name, `/prompts/get-conversation/${conversation_id}/${account_id}/${cognito_id}`,
    {
      headers: {
        Authorization: token
      }
    })
    .then((data) => {
      // Merge full conversation queries into the appropriate store
      if (data.success && data.payload) {
        const currentState = store.getState();
        
        if (project_id) {
          // Project KB conversation - update prompts.queries.list
          const currentQueries = currentState.prompts.queries?.list?.[project_id] || [];
          
          // Replace shallow queries with full versions
          const updated = currentQueries.map(q => {
            const fullVersion = data.payload.find(fq => fq.id === q.id);
            return fullVersion || q;
          });
          
          // Add any queries not already in the list
          data.payload.forEach(fq => {
            if (!updated.find(q => q.id === fq.id)) {
              updated.push(fq);
            }
          });
          
          dispatch({ type: ADD_QUERIES, payload: { 
            list: updated, 
            project_id
          } });
        } else {
          // Account assistant conversation - update accountAssistant.queries
          const currentQueries = currentState.accountAssistant?.queries || [];
          
          // Replace shallow queries with full versions
          const updated = currentQueries.map(q => {
            const fullVersion = data.payload.find(fq => fq.id === q.id);
            return fullVersion || q;
          });
          
          // Add any queries not already in the list
          data.payload.forEach(fq => {
            if (!updated.find(q => q.id === fq.id)) {
              updated.push(fq);
            }
          });
          
          dispatch({ type: SET_ACCOUNT_ASSISTANT_QUERIES, payload: updated });
        }
      }
      return data;
    })
    .catch((error) => {
      debug.error('[getFullConversation] Failed to fetch conversation', error);
      return {
        success: false,
        message: error.response?.data?.message || "Failed to fetch conversation"
      };
    });
};

export const updateQuery = (project_id, query_id, updates) => async (dispatch) => {
  return API.patch(Gateway.name, `/prompts/update-query/${project_id}/${query_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      updates
    },
  })
    .then((updated) => {
      dispatch({ type: UPDATE_QUERY, payload: updated.payload });
      return updated;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const deleteQuery = (project_id, query_id) => async (dispatch) => {
  return API.del(Gateway.name, `/prompts/delete-query/${project_id}/${query_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    }
  })
    .then((deleted) => {
      // Refresh queries list
      dispatch(getQueries(project_id, true));
      return deleted;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

/**
 * Fetch survey JSON (non-blocking). Do not await in UI-critical paths (e.g. loader, first paint).
 * Used by useSurveyCache, Survey, useSurveyState - all run in background; never block the KB loader.
 */
export const getSurveyJson = async (survey_id, all = false) => {
  if (!store.getState().session.authorized) return;
  // Build cache key (survey_id can be null for 'all')
  const key = `${survey_id || 'all'}::${all ? '1' : '0'}`;
  if (!window.__SURVEY_JSON_CACHE) {
    window.__SURVEY_JSON_CACHE = { data: {}, inFlight: {} };
  }
  const cache = window.__SURVEY_JSON_CACHE;
  // Return cached result if present (avoid refetching large payload repeatedly)
  if (cache.data[key]) return cache.data[key];
  // De-dupe concurrent requests
  if (cache.inFlight[key]) return cache.inFlight[key];
  let url = `/projects/get-json/${survey_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`;
  if (all) url += "?all=true";
  cache.inFlight[key] = API.get(Gateway.name, url, {
    headers: { Authorization: store.getState().session.token }
  })
  .then((data) => {
    cache.data[key] = data; // store successful response
    return data;
  })
  .catch((error) => {
    return {
      success: false,
      message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
    };
  })
  .finally(() => { delete cache.inFlight[key]; });

  return cache.inFlight[key];
};

export const setAdaptive = (config) => async (dispatch) => {
  dispatch({ type: SET_ADAPTIVE, payload: config });
};

export const createProjectMembership = (memberships, project_id, full) => async (dispatch) => {
  return API.post(Gateway.name, `/projects/create-membership/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      memberships,
      full
    },
  })
    .then((member) => {
      if (member.success) {
        dispatch(getProject(project_id, true));
        return dispatch(getAccountUsers(store.getState().session.account.account_id, store.getState().authentication.user.cognito_id, true))
          .then(async () => {
            await getUser(store.getState().authentication.user.cognito_id, store.getState().session.account.account_id, true);
            return member;
          });
      }
      return member;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const deleteProjectMembership = (membership_ids, project_id) => async (dispatch) => {
  return API.del(Gateway.name, `/projects/delete-membership/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      membership_ids
    }
  })
    .then((deleted) => {
      if (deleted.success) {
        return dispatch(getAccountUsers(store.getState().session.account.account_id, store.getState().authentication.user.cognito_id, true))
          .then(async (m) => {
            await getUser(store.getState().authentication.user.cognito_id, store.getState().session.account.account_id, true);
            dispatch(getProject(project_id, true));
            return m;
          });
      }
      return deleted;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const transferProject = (email, project_id, transfer_code) => async (dispatch) => {
  return API.post(Gateway.name, `/projects/transfer/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      email,
      project_id,
      transfer_code
    }
  })
    .then((response) => {
      dispatch(getProjects(true));
      dispatch(getAccounts(store.getState().authentication.user.cognito_id, store.getState().session.account.account_id, true));
      dispatch(showNotification("success", "Transfer Success", response.message));
      return response;
    })
    .catch((error) => {
      dispatch(showNotification("error", "Transfer Error", error.response && error.response.data ? error.response.data.message : "Something went wrong."));
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const translate = async (text, language) => {
  return API.post(Gateway.name, `/projects/translate/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      text,
      language
    }
  })
    .then((response) => {
      return response.payload;
    })
    .catch((error) => {
      return false;
    });
};

export const checkCalendarStatus = async (project_id) => {
  return API.get(Gateway.name, `/calendar/status/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return false;
    });
};

// Explicit manual sync trigger (forces sync regardless of staleness)
export const triggerCalendarSync = async (project_id) => {
  return API.get(Gateway.name, `/calendar/trigger-sync/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {}
  })
    .then((response) => response)
    .catch(() => false);
};

export const saveCalendarToken = async (project_id, creds) => {
  return API.post(Gateway.name, `/calendar/save-token/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {
      ...creds
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return false;
    });
};

export const getCalendarEvents = async (project_id) => {
  return API.get(Gateway.name, `/calendar/get-events/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    }
  })
    .then((response) => {
      // Dispatch events to Redux for MentionMenu and other consumers
      if (response?.success && Array.isArray(response.events)) {
        store.dispatch({
          type: 'SET_CALENDAR_EVENTS',
          payload: { project_id, events: response.events }
        });
      }
      return response;
    })
    .catch((error) => {
      return false;
    });
};

export const createCalendarEvent = async (project_id, data) => {
  return API.post(Gateway.name, `/calendar/create-event/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: data
  })
    .then((response) => {
      // Dispatch new event to Redux
      if (response && response.id) {
        store.dispatch({
          type: 'ADD_CALENDAR_EVENT',
          payload: { project_id, event: response }
        });
      }
      return response;
    })
    .catch(() => false);
};

export const updateCalendarEvent = async (project_id, event_id, data) => {
  return API.patch(Gateway.name, `/calendar/update-event/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}/${event_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: data
  })
    .then((response) => {
      // Dispatch update to Redux
      if (response) {
        store.dispatch({
          type: 'UPDATE_CALENDAR_EVENT',
          payload: { project_id, event_id, updates: response }
        });
      }
      return response;
    })
    .catch(() => false);
};

export const deleteCalendarEvent = async (project_id, event_id) => {
  return API.del(Gateway.name, `/calendar/delete-event/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}/${event_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    }
  })
    .then((result) => {
      // Dispatch deletion to Redux
      store.dispatch({
        type: 'DELETE_CALENDAR_EVENT',
        payload: { project_id, event_id }
      });
      return result;
    })
    .catch(() => false);
};

export const disconnectCalendar = async (project_id) => {
  return API.post(Gateway.name, `/calendar/disconnect/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: {
      Authorization: store.getState().session.token,
    },
    body: {}
  })
    .then((response) => response)
    .catch(() => false);
};

export const listCalendars = async (project_id) => {
  return API.get(Gateway.name, `/calendar/list-calendars/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token }
  })
    .then((response) => response)
    .catch(() => false);
};

export const selectCalendars = async (project_id, selected, default_calendar_id, settings, shares, colors) => {
  return API.post(Gateway.name, `/calendar/select-calendars/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
  body: { selected, default_calendar_id, settings, shares, colors }
  })
    .then((response) => response)
    .catch(() => false);
};

// Manual external calendar sources
export const listManualCalendarSources = async (project_id) => {
  return API.get(Gateway.name, `/calendar/manual-sources/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token }
  }).then(r => r).catch(() => false);
};

export const addManualCalendarSource = async (project_id, data) => {
  return API.post(Gateway.name, `/calendar/manual-sources/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body: data
  }).then(r => r).catch((error) => {
    return {
      success: false,
      message: (error && error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Failed to add calendar'
    };
  });
};

export const removeManualCalendarSource = async (project_id, source) => {
  return API.del(Gateway.name, `/calendar/manual-sources/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}?source=${encodeURIComponent(source)}`, {
    headers: { Authorization: store.getState().session.token }
  }).then(r => r).catch(() => false);
};

export const markManualCalendarSourceFailed = async (project_id, source, message) => {
  return API.patch(Gateway.name, `/calendar/manual-sources/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body: { source, failed: true, message }
  }).then(r => r).catch(() => false);
};

export const reactivateManualCalendarSource = async (project_id, source) => {
  return API.patch(Gateway.name, `/calendar/manual-sources/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body: { source, failed: false }
  }).then(r => r).catch(() => false);
};

// Rename manual calendar source (friendly name)
export const renameManualCalendarSource = async (project_id, source, calendar_name) => {
  return API.patch(Gateway.name, `/calendar/manual-sources/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
  body: { source, calendar_name }
  }).then(r => r).catch(() => false);
};

// Update manual calendar source color
export const updateManualCalendarSourceColor = async (project_id, source, color) => {
  return API.patch(Gateway.name, `/calendar/manual-sources/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body: { source, color }
  }).then(r => r).catch(() => false);
};

// Update underlying manual calendar source identifier (URL / ID)
export const updateManualCalendarSourceSource = async (project_id, source, new_source) => {
  return API.patch(Gateway.name, `/calendar/manual-sources/${project_id}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body: { source, new_source }
  }).then(r => r).catch(() => false);
};

// Set project as default for SMS queries
export const setProjectDefaultSMS = (account_id, cognito_id, project_id, is_default = true) => async (dispatch) => {
  try {
    const response = await API.post(
      Gateway.name,
      `/sms/set-default-project/${account_id}/${cognito_id}`,
      {
        headers: { Authorization: store.getState().session.token },
        body: { project_id, is_default }
      }
    );

    if (response.success) {
      // Refresh projects to get updated state
      dispatch(getProjects());
      // Refresh user to update project_memberships array
      const { getUser } = require('./user');
      await getUser(cognito_id, account_id, true);
    }

    return response;
  } catch (error) {
    debug.error("Error setting default SMS project", error);
    throw error;
  }
};

// Streaming chat for project creation
export const streamProjectCreationChat = async (message, collectedData, conversationHistory, options = {}) => {
  const state = store.getState();
  const account = state.session?.account;
  const user = state.authentication?.user;
  if (!account?.account_id) {
    throw new Error('Account not loaded. Please refresh or log out and log back in.');
  }
  if (!user?.cognito_id) {
    throw new Error('Session not ready. Please refresh or log out and log back in.');
  }
  const account_id = account.account_id;
  const token = state.session.token;
  const functionUrl = process.env.REACT_APP_CREATE_CHAT_URL ? `${process.env.REACT_APP_CREATE_CHAT_URL}/${account_id}/${user.cognito_id}` : null;

  if (!functionUrl) {
    throw new Error('Chat endpoint not configured');
  }

  try {
    const res = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        account_id,
        message,
        collected_data: collectedData,
        conversation_history: conversationHistory,
        mode: options.mode || 'client',
        survey_id: options.survey_id || null
      })
    });

    if (!res.ok || !res.body) {
      throw new Error('Streaming request failed');
    }

    return res;
  } catch (error) {
    debug.error("Error in project creation chat stream", error);
    throw error;
  }
};

// Account-level AI assistant with streaming
// query_source: 'accountchatsidebar' | 'globalsearch' (for admin metrics)
export const queryAccountAssistant = (query, project_id = null, conversation_id = null, mentions = [], query_source = 'accountchatsidebar') => async (dispatch, getState) => {
  const state = getState();
  // Use user's PRIMARY account, not switched context account (important for partners)
  const account_id = state.accounts.primary?.account_id || state.session.account?.account_id;
  const token = state.session.token;
  
  if (!account_id) {
    debug.error('[Account Assistant] No account_id available');
    throw new Error('Account not loaded');
  }
  
  // Get Function URL from environment
  const functionUrl = `${process.env.REACT_APP_ACCOUNT_ASSISTANT_URL}/${account_id}/${state.authentication.user.cognito_id}`;
  
  if (!functionUrl) {
    debug.error('[Account Assistant] Function URL not configured');
    throw new Error('Account assistant is not configured');
  }
  
  // Sanitize mentions: strip metadata, keep only essential fields for backend
  const sanitizedMentions = (mentions || []).map(m => ({
    type: m.type,
    id: m.id,
    name: m.name,
    token: m.token
  }));
  
  debug.log('account_assistant', '[Account Assistant] Starting query:', { query, project_id, conversation_id, mentions: sanitizedMentions.length });
  
  // Emit window event to start streaming (component handles state locally)
  window.dispatchEvent(new CustomEvent('account-assistant-stream', {
    detail: { type: 'start', query, project_id, conversation_id }
  }));
  
  try {
    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/x-ndjson'
      },
      body: JSON.stringify({
        account_id,
        query,
        project_id,
        conversation_id,
        mentions: sanitizedMentions,
        query_source
      })
    });
    
    if (!response.ok || !response.body) {
      throw new Error('Failed to start account assistant stream');
    }
    
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let fullResponse = '';
    let finalConversationId = conversation_id;

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';
      
      for (const line of lines) {
        if (!line.trim()) continue;
        
        try {
          const event = JSON.parse(line);
          
          switch (event.type) {
            case 'keepalive':
              // No-op: keeps connection alive so proxies don't close the stream
              break;

            case 'delta':
              fullResponse += event.data;
              window.dispatchEvent(new CustomEvent('account-assistant-stream', {
                detail: { type: 'delta', data: event.data }
              }));
              break;

            case 'tool_status':
            case 'status':
              // Emit custom event for component to handle locally (don't clutter Redux with transient streaming data)
              window.dispatchEvent(new CustomEvent('account-assistant-status', {
                detail: {
                  message: event.message,
                  details: event.details || null,
                  tool: event.tool || null
                }
              }));
              break;

            case 'tool_read':
              // "Read Lab_Results.pdf" style event — surfaces the model's actual read actions
              window.dispatchEvent(new CustomEvent('account-assistant-status', {
                detail: {
                  message: event.message,
                  details: null,
                  tool: event.tool || null,
                  read: true
                }
              }));
              break;
            
            case 'disambiguation':
              // Emit disambiguation event so external listeners can handle it
              window.dispatchEvent(new CustomEvent('account-assistant-stream', {
                detail: { 
                  type: 'disambiguation',
                  message: event.message,
                  options: event.options
                }
              }));
              return {
                success: true,
                disambiguation: true,
                message: event.message,
                options: event.options
              };
            
            case 'done':
              finalConversationId = event.conversation_id;

              // Emit done event with query record for component to handle
              window.dispatchEvent(new CustomEvent('account-assistant-stream', {
                detail: {
                  type: 'done',
                  query: event.query,
                  conversation_id: event.conversation_id,
                  conversation_title: event.conversation_title // Pass through title if available
                }
              }));

              return {
                success: true,
                response: fullResponse,
                conversation_id: event.conversation_id,
                usage: event.usage,
                tool_results: event.tool_results || []
              };
            
            case 'error':
              debug.error('[Account Assistant] Stream error:', event.message);
              // Emit done event to clear streaming
              window.dispatchEvent(new CustomEvent('account-assistant-stream', {
                detail: { type: 'done' }
              }));
              throw new Error(event.message || 'Stream error');

            default:
              // Ignore unknown event types
              break;
          }
        } catch (parseError) {
          debug.error('[Account Assistant] Parse error:', parseError, line);
        }
      }
    }

    // Emit done event to clear streaming (if we exit without 'done' event)
    window.dispatchEvent(new CustomEvent('account-assistant-stream', {
      detail: { type: 'done' }
    }));

    return {
      success: true,
      response: fullResponse,
      conversation_id: finalConversationId,
      tool_results: []
    };

  } catch (error) {
    debug.error('[Account Assistant] Error:', error);
    // Emit done event to clear streaming on error
    window.dispatchEvent(new CustomEvent('account-assistant-stream', {
      detail: { type: 'done' }
    }));
    throw error;
  }
};